/**
 * pages/RecipeManager.js
 * The "Resep" page — lists named recipes split by type (Rakit/Urai). Row click opens a read-only
 * detail; the Aksi cell has Detail + Hapus. Presentational: App owns the data, handlers, and modals.
 * Editing is a later session.
 */
import React, { useMemo, useState } from "react";
import { EyeIcon, PencilIcon, TrashIcon } from "../components/Icons";
import { resolveLineName } from "../components/LineName";

const TYPES = [
  { key: "ASSEMBLE", label: "Rakit (Assemble)" },
  { key: "TEARDOWN", label: "Urai (Teardown)" },
];

export default function RecipeManager({ recipes = [], items = [], onOpenRecipe, onEditRecipe, onDeleteRecipe }) {
  const [type, setType] = useState("ASSEMBLE");
  const byCode = useMemo(() => new Map(items.map((it) => [it.internalCode, it])), [items]);

  const list = useMemo(
    () => recipes.filter((r) => r.type === type).sort((a, b) => (a.name || "").localeCompare(b.name || "")),
    [recipes, type]
  );

  const lineLabel = (line) => {
    const { label, status } = resolveLineName(line, byCode);
    if (status === "missing") return line.internalCode;
    if (status === "deleted") return `${label} (dihapus)`;
    return label;
  };
  const summary = (r) => {
    if (r.type === "ASSEMBLE") {
      const out = (r.outputs || [])[0];
      return out ? `→ ${lineLabel(out)}` : "—";
    }
    const src = (r.inputs || [])[0];
    return src ? `${lineLabel(src)} →` : "—";
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Resep</h1>
          <div className="page-sub">{list.length} resep</div>
        </div>
      </div>

      <div className="toolbar">
        <div className="seg">
          {TYPES.map((t) => (
            <button type="button" key={t.key} className={type === t.key ? "active" : ""}
              onClick={() => setType(t.key)}>{t.label}</button>
          ))}
        </div>
      </div>

      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr><th>Nama</th><th>Ringkasan</th><th>Catatan</th><th>Aksi</th></tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr><td colSpan={4} className="empty-state">Belum ada resep {type === "ASSEMBLE" ? "Rakit" : "Urai"}.</td></tr>
            ) : (
              list.map((r) => (
                <tr key={r.id} onClick={() => onOpenRecipe(r.id)}>
                  <td><b>{r.name}</b></td>
                  <td>{summary(r)}</td>
                  <td>{r.note || "—"}</td>
                  <td className="row-actions" onClick={(e) => e.stopPropagation()}>
                    <button className="btn btn-sm btn-ghost" onClick={() => onOpenRecipe(r.id)}><EyeIcon /> Detail</button>
                    <button className="btn btn-sm btn-ghost" onClick={() => onEditRecipe(r)}><PencilIcon /> Ubah</button>
                    <button className="btn btn-sm btn-danger-ghost" onClick={() => onDeleteRecipe(r)}><TrashIcon /> Hapus</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
